import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {BookingV2StateService} from '../../../services/booking-v2-state.service';
import {AlertStateEnum} from '../../../enums/booking-enums';

@Component({
  selector: 'app-no-slots-available-redirected',
  templateUrl: './no-slots-available-redirected.component.html',
  styleUrls: ['./no-slots-available-redirected.component.scss'],
})
export class NoSlotsAvailableRedirectedComponent implements OnInit, OnDestroy {
  public isAlertVisible: boolean = false;
  private subscriptions: Subscription[] = [];

  constructor(private bookingState: BookingV2StateService) {}

  ngOnInit(): void {
    this.setListeners();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  private processAlertsState(state: number): void {
    this.isAlertVisible = state === AlertStateEnum.NO_TIMESLOTS_REDIRECTED;
  }

  private setListeners(): void {
    this.subscriptions.push(
      this.bookingState.state$.subscribe((result) =>
        this.processAlertsState(result.alert)
      )
    );
  }
}
